import { render, staticRenderFns } from "./pgToolTip.vue?vue&type=template&id=7b4423d4&scoped=true"
import script from "./pgToolTip.vue?vue&type=script&lang=js"
export * from "./pgToolTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4423d4",
  null
  
)

export default component.exports